export default {
    state: {
        items: [],
        discount_code: null
    },
    getters: {
        items: state => {
            return state.items;
        },
        total: state => {
            var total = 0;
            state.items.forEach(i => {
                total += i.priceWithDiscount;
            })
            let values = {
                price: total,
                priceWithDiscount: total
            }
            if(state.discount_code && state.discount_code.amount) total -= (state.discount_code.amount/100);
            if(total < 0) total = 0;
            values.priceWithDiscount = total;
            return values;
        },
        cartPlan: state => {
            return state.items[0] ? state.items[0].plan : null;
        },
        hasItems: state => {
            return state.items.length > 0;
        },
        hasItem: state => (code) => {
            state.items.forEach(i => {
                if(i.module.code == code) return i;
            })
            return {months: 0, days: 0}
        },
        hasDiscountCode: state => {
            if(state.discount_code) return true;
            else return false;
        },
        discountCode: state => {
            return state.discount_code;
        },
        hasOtherItems: state => (code) => {
            let hasOtherItems = false;
            state.items.forEach(i => {
                if(i.module.code != code) hasOtherItems = true;
            })
            return hasOtherItems;
        },
        numItems: state => {
            return state.items.length;
        },
        upgradeCosts: () => (plan, existingPlan) => {
            if(existingPlan.code == 'free' || existingPlan.code == 'student') return null;
            if(plan.code == existingPlan.code) return null;
            let paid_days_left = existingPlan.days_left
            if(paid_days_left == 0) return null;
            let priceUpgradePlan = Math.round(((paid_days_left * (plan.pricing_plans[0].price / 30)) + Number.EPSILON) * 100) / 100
            let priceCurrentPlan = Math.round(((paid_days_left * (existingPlan.pricing_plans[0].price / 30)) + Number.EPSILON) * 100) / 100
            return {
                days: paid_days_left,
                price: Math.round(((priceUpgradePlan - priceCurrentPlan) + Number.EPSILON) * 100) / 100
            }
        },
        monthlyPlanPrice: () => (months, plan) => {
            let response = {price: 0, priceWithDiscount: 0, majorDiscount: false, days: 0, months: months}
            let pricingPlan;
            for(let pp in plan.pricing_plans){
                if(plan.pricing_plans[pp].months == months) pricingPlan = plan.pricing_plans[pp];
            }
            response.price = (pricingPlan.price) + (pricingPlan.discount);
            response.priceWithDiscount = pricingPlan.price;
            return response;
        }
    },
    mutations: {
        ADD_ITEM(state, payload) {
            console.log(payload);
            //var exist = false;
            //for (var i in state.items) {
            //    if (state.items[i].module.id == payload.module.id) {
                    //state.items[i].months += payload.months;
            state.discount_code = null;
            state.items = [];
            state.items.push(payload);
            //        exist = true;
            //        break;
            //    }
            //}
            //if (!exist) {
            //    state.items.push(payload);
            //}
        },
        REMOVE_ITEM(state, payload) {
            state.items.splice(state.items.indexOf(payload), 1);
            state.discount_code = null;
        },
        UPDATE_ITEM(state, payload) {
            console.log(state, payload);
            for (var i in state.items) {
                if (state.items[i].module.id == payload.module.id) {
                    state.items[i].duration = payload.duration;
                    break;
                }
            }
        },
        RESET_CART(state) {
            state.items = [];
            state.discount_code = null;
        },
        ADD_DISCOUNT_CODE(state, discount_code) {
            state.discount_code = discount_code;
            if(discount_code.days) state.items[0].days = discount_code.days;
        },
        REMOVE_DISCOUNT_CODE(state) {
            state.discount_code = null;
            state.items[0].days = 0;
        }
    },
    actions: {
        ADD_ITEM: ({ commit }, payload) => {
            commit('ADD_ITEM', payload)
        },
        REMOVE_ITEM: ({ commit }, payload) => {
            commit('REMOVE_ITEM', payload)
        },
        UPDATE_ITEM: ({ commit }, payload) => {
            commit('UPDATE_ITEM', payload)
        },
        RESET_CART: ({ commit }) => {
            commit('RESET_CART')
        },
        ADD_DISCOUNT_CODE({ commit }, payload) {
            commit('ADD_DISCOUNT_CODE', payload)
        },
        REMOVE_DISCOUNT_CODE({ commit }) {
            commit('REMOVE_DISCOUNT_CODE')
        }
    }
}